<template>
    <div>
        <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="125"
              class="form-common">
            <Row>
                <FormItem label="客户名称" prop="cCusName">
                    <CusInputView v-model="application.cCusCode" :name.sync="application.cCusName"
                                  @on-success="handleCusSuccess"/>
                </FormItem>
                <FormItem label="订单时间" prop="dDate">
                    <DatePicker type="date" v-model="application.dDate" placeholder="请输入订单时间"
                                style="width: 200px"></DatePicker>
                </FormItem>
            </Row>
        </Form>
        <div class="btn-right">
            <Button type="primary" @click="skuSelectModel = true">存货选择</Button>
        </div>
        <CTable :columns="columns" :data="application.detailList" :showPage="false"/>
        <Row style="margin-top: 30px">
            <Col span="8" offset="8">
                <Button type="primary" @click="handleSubmit" style="width: 200px">提交</Button>
            </Col>
        </Row>
        <SkuSelectDialog :visible.sync="skuSelectModel" @on-select="onSkuSelect"></SkuSelectDialog>

    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {timeFormat, amountFormat, repalceGetParamsByObj} from '@/plugin/tool'
    import {auditStatusList, auditList} from '@/plugin/enum'
    import CusInputView from "../../components/CusInput/CusInputView";
    import SkuSelectDialog from "./SkuSelectDialog";

    //getCunhuoList 选择存货
    export default {
        name: 'SalesAppliList',
        mixins: [BtnEvent],
        components: {
            SkuSelectDialog,
            CusInputView,
            CTable
        },
        data() {
            return {
                skuSelectModel: false,
                date: [],
                vdate: [],//用于选择审核通过日期
                cusList: [],
                application: {
                    id: null,
                    detailList: [],
                },
                applicationRules: {},
                spList: auditList,
                total: 0,
                queryData: [], // 表格数据
                columns: [{
                    title: '存货编码',
                    key: 'cInvCode',
                    width: 240,
                }, {
                    title: '存货名称',
                    key: 'cinvname',
                    width: 340,
                }, {
                    title: '数量',
                    key: 'iQuantity',
                    width: 120,
                    render: (h, params) => {
                        return h('Input',
                            {
                                props: {
                                    type: 'text',
                                    value: params.row.iQuantity
                                },
                                on: {
                                    'on-change': (e) => {
                                        console.log(e)
                                        this.application.detailList[params.index].iQuantity = e.target.value
                                    }
                                }
                            })
                    }
                }, {
                    title: '单价',
                    key: 'iMoney',
                    minWidth: 120,
                    render: (h, params) => {
                        return h('Input',
                            {
                                props: {
                                    type: 'text',
                                    value: params.row.iMoney
                                },
                                on: {
                                    'on-change': (e) => {
                                        console.log(e)
                                        this.application.detailList[params.index].iMoney = e.target.value
                                    }
                                }
                            })
                    }
                }, {
                    title: '操作',
                    key: 'action',
                    width: 120,
                    render: (h, params) => {
                        return h('div', [
                            h('a', {
                                on: {
                                    click: () => {
                                        this.hnadleRemoveSku(params.row)
                                    }
                                }
                            }, '删除')
                        ])
                    }

                }],
            }
        },
        created() {
            var id = this.$route.query.id;
            if (id) {
                this.loadData();
            } else {

            }
        },
        methods: {
            loadData() {
                this.$fetch("SoSomain/getById", {id: this.$route.query.id})
                    .then(res => {
                        console.log(res)
                        this.application = res.data;
                        if (!this.application.detailList) {
                            this.application.detailList = []
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            handleCusSuccess(cus) {
                this.application.cCusName = cus.cCusName
                this.application.cCusCode = cus.cCusCode
            },
            onSkuSelect(list) {
                if (!this.application.detailList) {
                    this.application.detailList = []
                }
                _.forEach(list, item => {
                    let index = _.findIndex(this.application.detailList, src => {
                        return src.cinvcode === item.cinvcode
                    })
                    if (index === -1) {

                        var assign = Object.assign({}, item);
                        assign.cInvCode = assign.cinvcode;
                        assign.cInvName = assign.cinvname;
                        assign.iMoney = 0
                        assign.iQuantity = 0
                        this.application.detailList.push(assign)
                    }
                })
            },
            hnadleRemoveSku(item) {
                _.remove(this.application.detailList, sitem => {
                    return sitem.cInvCode === item.cInvCode
                })
                this.application.detailList.push({})
                this.application.detailList.pop()
            },
            handleSubmit() {
                this.$fetch("SoSomain/save", this.application, "POST")
                    .then(res => {
                        this.$Message.success("提交成功")
                        this.updatePagePath("/order/salesOrderList")
                    })
                    .catch(error => {
                        console.log(error)
                        this.$Message.warning("提交失败")
                    })
            }
        }
    }
</script>
